import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { usePost } from "redux/fetch-hooks";
import { Reaction } from "workstep/pages/Feedback/Comments/state/types";
import { useErrorToast, useDefaultToast } from "lib/hooks/toasts";
import HubNote from "employee/HubNote";
import FeatureFlag from "workstep/components/layout/FeatureFlag";

import MessageDisplay from "./Panes/MessageDisplay";

type MessageData = {
    subject: string;
    body: string;
    logo: string | null;
    checkin_url: string | null;
};

type StateType = {
    messageData: MessageData;
};

export default function SmsLandingPage({
    reaction,
    enableReactions = true,
    showToast = false,
}: {
    reaction?: Maybe<Reaction>;
    enableReactions?: boolean;
    showToast?: boolean;
}) {
    const errorToast = useErrorToast();
    const defaultToast = useDefaultToast();
    const messageData = useSelector<StateType, MessageData>((state) => state.messageData);
    const urlParams = new URLSearchParams(window.location.search);
    const [reactionState, setReactionState] = useState(reaction);
    const [setReaction, { isLoading }] = usePost<{ reaction: Maybe<Reaction> }>(
        window.location.pathname,
        {
            onSuccess: (data) => {
                setReactionState(data.reaction);
                if (data.reaction) {
                    defaultToast(`Your ${data.reaction?.emoji} has been saved`, {
                        anchorOrigin: {
                            vertical: "top",
                            horizontal: "right",
                        },
                    });
                }
            },
            onError: () => {
                errorToast("There was an error saving your reaction");
            },
        },
    );
    useEffect(() => {
        if (showToast && reaction) {
            defaultToast(`Your ${reaction.emoji} has been saved`, {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
        }
    }, []);

    // portal users from the dashboard link shouldn't actually upload
    const disableReactionSend = !!urlParams.get("d");
    const onReact = (val: Maybe<Reaction>) => {
        if (!disableReactionSend) {
            setReaction({ data: { reaction_type: val?.type || null } });
        }
    };
    return (
        <>
            <FeatureFlag featureName="hub-2-0">
                <HubNote />
            </FeatureFlag>
            <MessageDisplay
                subject={messageData.subject}
                body={messageData.body}
                logo={messageData.logo}
                checkinUrl={messageData.checkin_url}
                className="inform-sms"
                onReact={onReact}
                reactionLoading={isLoading}
                reaction={reactionState}
                enableReactions={enableReactions}
            />
        </>
    );
}
